import React from 'react'
import styled from 'styled-components'
import { getImportSourceLabelKey, IImportData } from '@root/query'
import { useTranslation } from 'react-i18next'
import { TransactionDetails } from '@root/containers/TransactionDetails'
import { OnHoverContainer } from '@root/components'

interface Props {
  importData: IImportData
  children: React.ReactElement
}

const BankTransactionHover: React.FC<Props> = ({ importData, children }) => {
  const [t] = useTranslation()

  return (
    <OnHoverContainer
      content={
        <ScrollableContent>
          <StyledMainHeader>
            {t(
              `document.importSource.hoverTitle.${getImportSourceLabelKey(importData.data_source)}`
            )}
          </StyledMainHeader>
          <TransactionDetails import_data={importData}></TransactionDetails>
        </ScrollableContent>
      }
    >
      {children}
    </OnHoverContainer>
  )
}

export default BankTransactionHover

const StyledMainHeader = styled.h3`
  margin-bottom: ${({ theme }) => theme.spacing.md}rem;
`

export const ScrollableContent = styled.div`
  flex: 1;
  overflow: auto;
  max-width: 300px;
`
